const modalsConfig = {
  carouselModal: {
    resolve: () => import('../modules/carousel-modal')
  },
  prospectRegModal: {
    resolve: () => import('../modules/prospect-reg-modal')
  },
  academyVideoModal: {
    resolve: () => import('../modules/academy-video-modal')
  }
};

export {
  modalsConfig
};

